import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { CONSTANTS } from '../shared/constants';
import { MatDialogConfig } from '@angular/material/dialog';
import { SessionEndComponent } from '../components/modals/session-end/session-end.component';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { LoadingAkanaService } from './loading-akana.service';

declare var window;
declare let OneTrust;

@Injectable({
  providedIn: 'root'
})
export class CommonsService {

  currentUrl: any;
  headers = new HttpHeaders();
  entities: any;
  options: any;
  kpis: any;
  dataSCA: any;
  polity: number;
  terms: number;
  sec: any;

  constructor(private modal: MatDialog, private r: Router, private l: LoadingAkanaService) { }

  setCurrentUrl(url, options?) {
    this.currentUrl = url;
    this.options = options;
  }

  getOptions() {
    return this.options;
  }

  getCurrentUrl() {
    return this.currentUrl = (this.currentUrl) ? this.currentUrl : JSON.parse(sessionStorage.getItem('current_view'));
  }

  setEntities(banks: any) {
    this.entities = banks;
  }

  getEnt() {
    return this.entities;
  }

  setKpi(kpis: any) {
    sessionStorage.setItem('A_profile', (kpis.Channel === 5 || kpis.Channel === 2) ? 'Y_P' : 'N_P');
    sessionStorage.setItem('change_pass_SCF', kpis.Channel === 2 ? 'Y_P' : 'N_P');
    this.kpis = kpis;
    this.refreshToken(kpis);
  }

  getKpi() {
    return this.kpis;
  }

  setServiceSCA(data) {
    this.dataSCA = data;
  }

  getServiceSCA() {
    return this.dataSCA;
  }

  /**
   * 
   * @param param parametro a encriptar
   */
  encrypt(param) {
    return window.btoa(unescape(encodeURI(JSON.stringify(param))));
  }

  /**
   * 
   * @param param paramentro a desencriptar
   */
  decrypt(param) {
    return JSON.parse(decodeURIComponent(escape(window.atob(param))));
  }

  setTermsFooter(terms) {
    this.terms = terms;
  }

  getTermsFooter() {
    return this.terms;
  }

  setPolityFooter(polity) {
    this.polity = polity;
  }

  getPolityFooter() {
    return this.polity;
  }

  getNameEntity(account: string) {
    let name = '';
    CONSTANTS.entities.forEach(data => {
      if (data.code === account.substr(0, 4)) {
        name = data.name;
      }
    });
    return name;
  }

  finishSession(rmToken?) {
    sessionStorage.removeItem('login_polity');
    sessionStorage.removeItem('polity');
    sessionStorage.removeItem('terms');
    sessionStorage.removeItem('ofers');
    sessionStorage.removeItem('_k');
    sessionStorage.removeItem('k_ca');
    sessionStorage.removeItem('form');
    sessionStorage.removeItem('A_profile');
    sessionStorage.removeItem('form_sign');
    sessionStorage.removeItem('refreshEntityCode');
    sessionStorage.removeItem('banksEntities');
    sessionStorage.removeItem('change_pass_SCF');
    sessionStorage.removeItem('_tips');
    sessionStorage.removeItem('gs');
    if (rmToken) {
      sessionStorage.removeItem('t');
    }
  }

  googleAnalitycs(bank?, tittle?, action?, client?) {
    window.dataLayer.push({
      event: 'ananalyticsevent',
      eventCategory: 'conversion',
      eventAction: action, // accion realizada
      eventLabel: bank, // nombre del banco agregado
      pageType: 'confirmacionCuenta',
      pageTitle: tittle, // titulo de la pagina
      userstatus: 'logged', // SI TENEIS LOGGIN
      usertype: client, // SI DISTINGUIS POR TIPO DE USUARIO – Cliente del Santander / No cliente
      user_GA_ID: this.getCookieValue('_ga'), // coger cookie de datanicals
      user_id: sessionStorage.getItem('hash-datanicals')
    });
  }

  /**
   * rellena este objeto nada mas cargar la vista, con un nombre de la vista, tipo de accion y contenido (funnel, content)
   * @param nombre: string
   * @param tipo string
   * @param content string
   */
  firstChargePage(nombre?, tipo?, content?) {
    window.dataLayer = window.dataLayer || [];
    const d = () => new Date();
    const arrayDays = ['Domingo', 'Lunes', 'Martes', 'Miercoles', 'Jueves', 'Viernes', 'Sabado'];
    const campaigns = sessionStorage.getItem('datanicalsParams') ? JSON.parse(sessionStorage.getItem('datanicalsParams'))
      : [{ name: '', value: '' }];
    window.dataLayer.push({
      event: 'analyticspageview',
      content: {
        category: content,
        country: 'spain',
        date: d().getFullYear().toString() + (d().getMonth() + 1).toString() + d().getDate().toString(),
        asset: 'akanamainweb',
        host: 'www.akana.es',
        language: 'spanish',
        mode: window.innerWidth > 768 ? 'Desktop' : 'Mobile',
        pageType: tipo,
        pageName: nombre,
        referrer: window.location.origin,
        url: window.location.href,
        subCategory4: '',
        time: d().getHours() + ':' + ((d().getMinutes() < 10) ? ('0' + d().getMinutes()) : d().getMinutes()) + ':' + d().getSeconds(),
        weekday: arrayDays[d().getDay()]
      },
      user: {
        gaclient: this.getCookieValue('_ga'),
        adblock: 'disabled',
        useragent: window.navigator.userAgent,
        subcribedNewsleeter: '',
        logged: 'no logado',
        idcrm: '',
        lastlogin: '',
        porduct1: '',
        registrationDate: '',
        gender: '',
        age: '',
        province: '',
        city: '',
        isClient: '',
        ponehash: '',
        mailhash: '',
      },
      campaign: {
        campaign: this.searchParam(campaigns, 'utm_campaign'),
        trafficsource: '', // this.searchParam(campaigns, ''),
        medium: '', // this.searchParam(campaigns, ''),
        term: this.searchParam(campaigns, 'utm_term'),
        content: this.searchParam(campaigns, 'utm_content'),
        glcid: this.searchParam(campaigns, 'gclid')
      },
      transaction: {
        id: ''
      }
    });

  }

  eventsAnalitics(event, action, namePage) {
    let obj = {
      event: 'ananalyticsevent',
      eventCategory: event, // 'Visit Screen o click',
      eventAction: action, // 'Accion que se ejecuta',
      eventLabel: namePage, // 'nombre de la pagina' o nombre de evento
      eChannel: sessionStorage.getItem('Channel') ? sessionStorage.getItem('Channel') : 'Akana_web'
    };

    window.dataLayer.push(obj);
  }

  searchParam(cam, param) {
    const value = cam.filter(d => d.name === param);
    if (value.length) {
      return value[0].value;
    } else {
      return '';
    }
  }

  private refreshToken(kpis: any) {
    if (kpis.Token) {
      sessionStorage.removeItem('t');
      sessionStorage.setItem('t', kpis.Token);
    }
  }

  private getCookieValue(value) {
    const v = document.cookie.split(';').filter(d => d.includes(value));
    return v ? '' : v[0].split('=')[1];
  }

  reloadOTBanner() {
    const script5 = document.createElement('script');
    script5.setAttribute('type', 'text/javascript');
    script5.innerHTML = 'function getCookie(name) { var value = "; " + document.cookie; var parts = value.split("; " + name + "="); if (parts.length == 2) { return true } }' +
    'function reloadOTBanner() {if (!getCookie("OptanonAlertBoxClosed")) { var otConsentSdk = document.getElementById("onetrust-co"); } if (otConsentSdk) { otConsentSdk.remove(); }if (window.OneTrust != null) {OneTrust.Init();setTimeout(function () { OneTrust.LoadBanner();var toggleDisplay = document.getElementsByClassName("ot-sdk-show-settings");for (var i = 0; i < toggleDisplay.length; i++) {toggleDisplay[i].onclick = function (event) {event.stopImmediatePropagation();window.OneTrust.ToggleInfoDisplay();}}}, 1000);}}';
    script5.setAttribute('title', 'Reload');
    document.body.appendChild(script5);
  }

  clearDup() {
    const script6 = document.createElement('script');
    script6.setAttribute('type', 'text/javascript');
    script6.innerHTML = 'function clearDup(){var  sec=document.getElementById("ot-sdk-cookie-policy");if(!sec){ return; } var tally=[];for (var i=sec.length-1;i>=0;i--) {if(tally[sec[i].firstChild.innerText]===undefined) {tally[sec[i].firstChild.innerText]=1;} else {sec[i].remove()}}} clearDup();';
    script6.setAttribute('title', 'ClearDup');
    document.body.appendChild(script6);
  }

  getBanner() {
    OneTrust.ToggleInfoDisplay();
  }

  openModalSession(modal?) {
    const modalConfig = new MatDialogConfig();
    modalConfig.width = '90%';
    modalConfig.id = 'modal-info';
    modalConfig.maxWidth = '320px';
    modalConfig.disableClose = true;
    this.eventsAnalitics('click', 'Modal de cierre de sesión automatico por inactividad', 'Modal de informacion');
    const mod = this.modal.open(SessionEndComponent, modalConfig);
    mod.afterClosed().subscribe((d: any) => {
      const ss = sessionStorage.getItem('A_profile');
      this.finishSession(true);
      document.querySelector('body').style.overflow = '';
      if (ss && ss === 'Y_P') {
        this.r.navigateByUrl('signin');
      } else {
        this.r.navigateByUrl('terms');
      }
    });
  }
}
